$(function () {
    'use strict';

    var $fileInput = $('.fileinput-button');
    var scripts = ['jquery.ui.widget.js',
        'tmpl.min.js',
        'load-image.all.min.js',
        'canvas-to-blob.min.js',
        'jquery.iframe-transport.js',
        'jquery.fileupload.js',
        'jquery.fileupload-process.js',
        'jquery.fileupload-image.js',
        'jquery.fileupload-audio.js',
        'jquery.fileupload-video.js',
        'jquery.fileupload-validate.js',
        'jquery.fileupload-ui.js'];

   if($fileInput.length){
        var dataUploader = $fileInput.data('uploader-url');
        $.each( scripts, function( key, value ) {
            $('head').append($('<script/>').attr('src', dataUploader+'js/'+value));
        });
    }

    if($fileInput.length){
        var url = dataUploader;
        $('.uploadedlink').lightbox();

        $('#fileupload').fileupload({
            // Uncomment the following to send cross-domain cookies:
            //xhrFields: {withCredentials: true},
            url: url,
            autoUpload: true
        });

        // Enable iframe cross-domain access via redirect option:
        $('#fileupload').fileupload(
            'option',
            'redirect',
            window.location.href.replace(
                /\/[^\/]*$/,
                '/cors/result.html?%s'
            )
        ).on('fileuploadsuccess', function (e, data) {
            $('.uploaded-files').append($('<option />').val(data.result.files[0].name).attr('selected', 'selected'));
            setTimeout(function(){
               $('.uploadedlink').lightbox();

            }, 100)

        });

        // Load existing files:
        $('#fileupload').addClass('fileupload-processing');
        $.ajax({
            // Uncomment the following to send cross-domain cookies:
            //xhrFields: {withCredentials: true},
            url: $('#fileupload').fileupload('option', 'url'),
            dataType: 'json',
            context: $('#fileupload')[0]
        }).always(function () {
            $(this).removeClass('fileupload-processing');
        }).done(function (result) {
            $(this).fileupload('option', 'done')
                .call(this, $.Event('done'), {result: result});
        });
    }
});
